import React from "react";
import { FileDetails } from "src/entity/manual-sampling/manual-sampling.entity";
import FileIcon from "./FileIcon";

interface FileDescriptionListProps {
  files: FileDetails[];
}

const FileDescriptionList: React.FC<FileDescriptionListProps> = ({ files }) => {
  const createDescFile = (files: FileDetails[]): JSX.Element[] => {
    return files.map((file, index) => (
      <span key={index} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {<FileIcon fileName={file.originalName} />}
        {file.originalName}
      </span>
    ));
  };

  return <div>{createDescFile(files)}</div>;
};

export default FileDescriptionList;
